/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import BaseCardLayoutActions from "../base-card-layout/base-card-layout-actions";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutFormCreate from "./checkout-form-create";
import { Modal } from "../modal/modal";
import OrganizationService from "../../utilities/services/organization-service";
import { PaymentCycle } from "../../models/enumerations/payment-cycle";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { LicenseLimitPlanType } from "../../models/enumerations/license-limit";
import { UserLimitPlanType } from "../../models/enumerations/user-limit";
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
import { Organization } from "../../models/interfaces/organization";
import { User } from "../../models/interfaces/user";
import { useTranslation } from "react-i18next";
import { PlanTypeLabels } from "../../models/plan-type";
import { Price } from "../../models/interfaces/price";
import { Product } from "../../models/interfaces/product";
import { PlanIdPlanType } from "../../models/enumerations/plan-id";

interface StripePayProps {
  onSubmitClick: () => void;
  onBackClick?: () => void;
  onChange?: () => void;
  onInfoCreate: (user: User, organization: Organization) => Promise<string>;
  selectedProduct?: Product;
  selectedPrice?: Price;
}

const StripePay: React.FC<StripePayProps> = ({ onBackClick, onSubmitClick, onChange, onInfoCreate, selectedProduct, selectedPrice }) => {
  const { t } = useTranslation();
  const db = getFirestore();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);
  const [paymentFailedModalOpen, setPaymentFailedModalOpen] = useState<boolean>(false);
  const [paymentSuccessful, setPaymentSuccessful] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [paymentFailed, setPaymentFailed] = useState<boolean>(false);
  const [paymentCycle, setPaymentCycle] = useState<PaymentCycle>(PaymentCycle.Monthly);
  const [startSubscription, setStartSubscription] = useState<number>(0);
  const [products, setProducts] = useState<any>();
  const { state, setState } = useAuthState();

  useEffect(() => {
    if (state.temp.product) {
      setPaymentCycle(state.temp.product.interval);
    }
  }, [state]);

  useEffect(() => {
    const getProductsAndPrices = async () => {
      setIsLoading(true);

      const products: any[] = [];
      const q = query(
        collection(db, 'products'),
        where('active', '==', true),
      );

      const querySnapshot = await getDocs(q);

      // for each product, get the product price info
      querySnapshot.docs.map(async (productDoc) => {

        let prices: any[] = [];

        // fetch prices subcollection per product
        const pricesCollection = collection(productDoc.ref, 'prices');
        const priceQuerySnapshot = await getDocs(pricesCollection);

        // loop through difference business prices
        priceQuerySnapshot.docs.forEach((item) => {

          prices.push({ data: item.data(), id: item.id });
        })
        products.push({
          product: { data: productDoc.data(), id: productDoc.id },
          prices: prices
        })
      });
      await setProducts(products);

      setIsLoading(false);
    }
    getProductsAndPrices();
  }, [])

  const updateOrg = async () => {
    // Get Organization
    if (!state.temp.organization.id || !state.temp.product || !state.temp.product.id) {
      // Couldn't get organization id or product
      return;
    }

    setIsLoading(true);

    const o = await OrganizationService.get(state.temp.organization.id);
    const purchasedProductId: string = state.temp.product.id;
    const purchasedPlanType = PlanIdPlanType[purchasedProductId];

    if (o && purchasedPlanType) {
      o.plan = { value: purchasedPlanType, label: PlanTypeLabels[purchasedPlanType] };
      o.userLimit = UserLimitPlanType[purchasedPlanType];
      o.organizationLimit = 1;
      o.userCount = 1;
      o.organizationLimit = 1;
      o.mySymmioLicense = LicenseLimitPlanType[purchasedPlanType];
      const updatedOrg = await OrganizationService.save(o);

      setState((state) => ({
        ...state, ...{
          organization: {
            ...updatedOrg,
          },
        }
      }));

      setIsLoading(false);

      onSubmitClick();
    }
  }

  useEffect(() => {
    const openModal = async () => {
      if (paymentSuccessful) {
        updateOrg();
        // setGetPayment(false);
      }
      else if (paymentFailed) {
        // setGetPayment(false);
        setPaymentFailedModalOpen(true);
      }
    }
    openModal();

  }, [paymentFailed, paymentSuccessful])

  const handleStartSubscription = () => {
    setStartSubscription(startSubscription + 1);
  }

  return (
    <>
      {stripePromise && (
        <Elements stripe={stripePromise} options={{ mode: 'setup', currency: 'usd' }}>
          <CheckoutFormCreate
            isCreating={true}
            products={products}
            paymentSuccessful={setPaymentSuccessful}
            paymentFailed={setPaymentFailed}
            onChangePlan={onChange}
            returnUrl={``}
            paymentCycle={paymentCycle}
            checkoutFlag={startSubscription}
            onInfoCreate={onInfoCreate}
            selectedProduct={selectedProduct}
            selectedPrice={selectedPrice}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </Elements>
      )}
      <BaseCardLayoutActions
        backButton={true}
        backDisabled={isLoading}
        submitDisabled={isLoading}
        submitButton={true}
        onSubmit={handleStartSubscription}
        submitButtonText={t('buttons.btn_startSub')}
        onBack={onBackClick}
      />
      <Modal
        isOpen={paymentFailedModalOpen}
        isLoading={false}
        onClose={() => {
          setPaymentFailedModalOpen(false);
        }}
        title={t('pricing.checkoutPage.paymentDeclined.title')}
        defaultCenterModal={true}
        submitButtonText={t('buttons.btn_continue')}
        onSubmit={() => {
          setPaymentFailedModalOpen(false)
        }}>
        <div>
          <p><b>{t('pricing.checkoutPage.paymentDeclined.line1')}</b></p>
          <p>{t('pricing.checkoutPage.paymentDeclined.line2')}</p>
          <p>{t('pricing.checkoutPage.paymentDeclined.line3')}</p>
        </div>
      </Modal>
    </>
  );
}

export default StripePay;

